import { render } from "./TheHeader.vue?vue&type=template&id=23ec24c2&scoped=true"
const script = {}

import "./TheHeader.vue?vue&type=style&index=0&id=23ec24c2&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-23ec24c2"

export default script